import React, { Component } from 'react'
import {Chart, registerables} from "chart.js";
import 'chartjs-adapter-luxon'

import "./LineGraph.css";

export default class LineGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
    this.lastLabel = null;
    this.labelLength = 0;
    this.scale = props.zoom ? props.zoom : 1;
    this.chartLineColor = '#007ac0';
    this.dcLineColor = 'DarkRed'
    this.myLineChart = undefined;
    this.chartRef = React.createRef();
  }
 
  componentDidMount() {
    Chart.register(...registerables);
    this.buildChart();

    // Set canvas height after chart creation
    //const canvas = this.chartRef.current;
    //canvas.height = 200; // Set desired height
  }

  componentDidUpdate() {
    this.scale = this.props.zoom ? this.props.zoom : this.scale;
    this.buildChart();
  }
  componentWillUnmount() {
    if (typeof this.myLineChart !== "undefined")
      this.myLineChart.destroy();
  }
  dc(inBand) {
    return (inBand === 4294967295 || inBand === -1)
  }
  buildChart = () => {
    const myChartRef = this.chartRef.current.getContext("2d");

    const labelset = this.props?.label;
    this.lastLabel = labelset[labelset?.length-1];
    this.labelLength = labelset?.length;
 
    let bargradient = myChartRef.createLinearGradient(0, 0, 0, 500);
    bargradient.addColorStop (0, 'rgba(0, 192, 166, 0.5)');
    bargradient.addColorStop (1.0, 'rgba(0, 192, 166, 0.5)');

    let chartObj = this.chartObjCommon(this.chartLineColor);
    chartObj.type = 'bar';
    if (! (this.props.series2 === null || this.props?.series2 === undefined)) {
      chartObj.data.datasets.push({
        label: 'Consumption',
        borderColor: 'rgba(0, 192, 166,0.5)',
        borderWidth: 1,
        backgroundColor: bargradient,
        data: this.props.series2,
        yAxisID: "right-y-axis",
        categoryPercentage: 0.6,
      })
      // right hand axes options
      chartObj.options.scales["right-y-axis"] = {
        type: 'linear',
        position: 'right',
        grid: {display: false},
        grace: '150%',
      }
    }
      if (typeof this.myLineChart !== "undefined") this.myLineChart.destroy();
      this.myLineChart = new Chart(myChartRef, chartObj);
    return;
  }

  chartObjCommon(lineColor) {
    let plotable = this.props.data
    let dcData = false
    if (Array.isArray(this.props.data)) {
      plotable = this.props.data.filter(i => !isNaN(i))
      dcData = this.dc(Math.max(...plotable))
    }
    const animationTime = this.props.label.length < 400 ? 1000 : 0;
    const timeconfig = this.timeSeriesTicks();
    const cdata = this.formatDataset(lineColor, dcData)
    let chartObj = {
      defaults: {
        font: "'PT Sans', sans-serif",
      },
      data: cdata,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: { duration: animationTime },     // general animation time 
        hover: { animationDuration: animationTime }, // hover animation time
        responsiveAnimationDuration: animationTime,  // animation duration after a resize 
        barPercentage:1.3,
        plugins: {
          legend: {display: false},
          tooltip: {
            callbacks: {
              label: function(context) {
                let label = context.dataset.label || '';
                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  if (context.parsed.y === 4294967295 || context.parsed.y === -1)
                    label += "Disconnected"
                  else 
                    label += new Intl.NumberFormat().format(context.parsed.y)
                }
                return label
              }
            }
          }
        },
        scales: {
          x: {
            type: 'time',
            distribution: 'linear',
            ...timeconfig,
            ticks: { display: true },
            grid: {display: false},
         },
          y: {
            id: 'readings',
            type: 'linear',
            position: 'left',
            ticks: { display: true },
            grid: {display: false},
            beginAtZero: false,
            suggestedMin: this.props?.yscale?.suggestedMin,
            suggestedMax: this.props?.yscale?.suggestedMax,
            display: cdata?.datasets[0]?.data?.some(i => typeof i === 'number' && isNaN(i) === false),
         },
        }
      } 
    }
    return chartObj;
  }
  formatDataset(lineColor, hasDC) {
    let grouped = {conn: this.props.data}
    if (hasDC) {
      grouped = this.groupDC(this.props.data, hasDC)
    }
    let pointFormat = {
      datasets: [{
        label: 'Reading',
        data: grouped.conn,
        borderColor: lineColor,
        fill: true,
        backgroundColor: 'transparent',
        type: 'line',
     }],
      labels: this.props.label,
    }
    if (hasDC) {
      pointFormat.datasets.push ({
        label: ' ',
        data: grouped.dc,
        borderColor: this.dcLineColor,
        fill: true,
        backgroundColor: 'transparent',
        type: 'line',
        pointStyle: 'crossRot',
        pointRadius: 6,
      })
    }
    return pointFormat
  }
  groupDC (allPoints, hasDC) {
    if (!hasDC || !Array.isArray(allPoints))
      return {conn: allPoints}
    const groupA = allPoints.map(p => !this.dc(p) ? p : undefined)
    const groupB = allPoints.map(p => this.dc(p) ? -1 : undefined) 
    return {conn: groupA, dc: groupB}
  }
  timeSeriesTicks () {
    const timeSeries = this.props.label
    if (timeSeries && timeSeries.length > 0) {
      const interval = Math.abs(timeSeries[timeSeries.length-1] - timeSeries[0]) / (1000*60*60)
      const options = [{name:'hour', max: 48, scale:1}, {name:'day', max: 24*7, scale:24}, 
        {name: 'week', max:24*7*6, scale:24*7}, {name: 'month', max:Number.MAX_VALUE, scale:24*30 }]
      const unitIndex = options.findIndex (opt => opt.max >= interval)
      const step = Math.max((interval / options[unitIndex].scale) / 5, 1)
      return {time: {unit: options[unitIndex].name, stepSize: step, }}
    } 
    return {time: {unit: 'hour', stepSize: 1, }}
  }
  render() {
    const container = this.props?.container ?? "graphContainer"
    return (
      <div className={container}>
        <canvas id="myChart" ref={this.chartRef} />
      </div>
    )
  }
}
